import { render } from "./helpPage.vue?vue&type=template&id=1e2fe81d"
import script from "./helpPage.vue?vue&type=script&lang=js"
export * from "./helpPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__